import type { Translatable } from "app/pages/sales-intelligence/types";

export const UNKNOWN_NAME_TRANSLATABLE: Readonly<Translatable> = { key: "Unknown name" };
